import {ThemingStore} from "../../../theming/store/ThemingStore";
import {IDirective} from "angular";
import {Observable, Subscriber} from "rxjs";

export const SlimScroll = "slimScroll";

/** @ngInject */
export function slimScroll(themingStore: ThemingStore): IDirective {
    return {
        restrict: "A",
        link($scope, $element, $attrs) {

            const alwaysVisible = $scope.$eval($attrs["slimscrollAlwaysVisible"]);

            const mutation$ = createMutationObserver($element[0], alwaysVisible).startWith(true)
                                                                                .auditTime(1000);
            const theme$ = themingStore.currentTheme.distinctUntilChanged();

            const source$ = Observable.combineLatest(theme$, mutation$);

            const sub = source$.map(([theme, _]) => theme)
                               .subscribe((theme) => {
                                   const color = (theme === "light") ? "#000000" : "#FFFFFF";
                                   const $el = $($element[0]);
                                   const opts = {
                                       height: $attrs.scrollHeight || "100%",
                                       alwaysVisible,
                                       allowPageScroll: true,
                                       color
                                   };
                                   $el.slimScroll(opts);
                               });

            $scope.$on("$destroy", () => sub.unsubscribe());
        }
    };
}

function createMutationObserver(target: Element, alwaysVisible: boolean): Observable<boolean> {
    return Observable.create((subscriber: Subscriber<boolean>) => {
        if (("MutationObserver" in window) && alwaysVisible) {
            let previousHeight = target.scrollHeight;
            const observer = new MutationObserver((mutations) => {
                if (mutations.length > 0) {
                    if (target.scrollHeight !== previousHeight) {
                        previousHeight = target.scrollHeight;
                        subscriber.next(true);
                    }
                }
            });
            observer.observe(target, {
                childList: true,
                subtree: true
            });
            subscriber.add(() => observer.disconnect());
        }
    });
}
